<template>

        <div :id="problem.id" :class="'accordion-section'+ (problem.open?' active':'')" v-if="problem.data">
          <div class="accordion-header" @click="problem.open = !problem.open">
            <div class="accordion-title">
              <i :class="'bi '+ problem.ico"></i> {{ problem.name }}
              <span :class="'accordion-badge ' + (problem.errors <= 0?'success':problem.errors<2?'info':problem.errors<20?'warning':'critical')">{{ problem.errors }} ошибок</span>
            </div>
            <div class="accordion-icon">▼</div>
          </div>
          <div :class="'accordion-content'+ (problem.open?' active':'')">
            <h3>📊 Статус по проектам</h3>
            <table class="data-table">
              <thead>
              <tr>
                <th>Проект</th>
                <th>Email</th>
                <th>Последний запуск</th>
                <th>Следующей запуск</th>
                <th>Глубина сбора</th>
                <th>Ошибок</th>
                <th>%</th>
              </tr>
              </thead>
              <tbody>
              <template v-if="problem.data">
              <tr v-for="project in problem.data">
                <td><strong>{{ project.name }} </strong>
                  <strong>(ID: {{ project.id }})</strong></td>
                <td>{{ project.email }} </td>
                <td>{{project.last_parser?$moment(project.last_parser).format("DD.MM.YYYY HH:mm"):'-'}}</td>
                <td>{{project.next_start?$moment(project.next_start).format("DD.MM.YYYY HH:mm"):'-'}}</td>
                <td>{{project.deep}}</td>
                <td><strong>{{project.errors}}</strong></td>
                <td>
                  <div class="progress-bar">
                    <div class="progress-fill success"
                         :style="{width: $widthratio(project.ready, project.all) + '%'}"></div>
                  </div>
                  <small>{{project.ready}}/{{project.all}} ({{$widthratio(project.ready, project.all) + '%'}})</small>
                </td>
              </tr>
                </template>
              <tr v-else>
                <td colspan="3">Нет ошибок</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>


</template>

<script>

export default {
  name: 'ProjectInfo',
  data() {
    return {}
  },
  props: {
    problem: {
      type: Object,
      default: () => {
      }
    }
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">

</style>